export const uploadImage = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) { resolve(null); return; }
      
      // Asegúrate de tener estas variables en tu .env o hardcodeadas aquí para probar
      const cloudName = process.env.REACT_APP_CLOUDINARY_NAME || "tu_cloud_name"; 
      const uploadPreset = process.env.REACT_APP_CLOUDINARY_PRESET || "tu_preset";
      
      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', uploadPreset);
      
      fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (data.secure_url) {
            resolve(data.secure_url);
          } else {
            reject(data.error || 'Fallo la subida a Cloudinary');
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  };